/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lifeScenario/job': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<path pid="0" d="M16 2a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h4.18C6.6.84 7.7 0 9 0c1.3 0 2.4.84 2.82 2H16zM9 2a1 1 0 100 2 1 1 0 000-2zM4 6V4H2v14h14V4h-2v2H4zm5 2a2 2 0 110 4 2 2 0 010-4zm-4 8v-1c0-1.1 1.79-2 4-2s4 .9 4 2v1H5z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
